import { Modal, Sidebar } from 'components';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import messages from 'utils/intl-messages';
import { needsSimpleTemplate } from 'utils/route';

export default class App extends Component {

  /* Lifecycle */

  componentWillMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const shoppingCartToken = urlParams.get('token') || localStorage.getItem('shoppingCartToken');

    if (shoppingCartToken) {
      this.props.shoppingCartSetToken(shoppingCartToken);
    }

    const { query } = this.props.routing.locationBeforeTransitions;

    if (query.lang) {
      const locale = query.lang;
      this.props.changeLanguage({
        locale,
        messages: messages(locale),
      });
    }
  }

  /* Render */

  render() {
    const {
      children,
      routing: { locationBeforeTransitions },
    } = this.props;

    if (!locationBeforeTransitions) return null;

    if (needsSimpleTemplate(locationBeforeTransitions.pathname)) {
      return (
        <div className="app">
          {children}
        </div>
      );
    }

    return (
      <div className="app">
        <div className="app__sidebar">
          <Sidebar />
        </div>
        <div className="app__content">
          {children}
        </div>
        <Modal />
      </div>
    );
  }
}

App.propTypes = {
  changeLanguage: PropTypes.func,
  children: PropTypes.node,
  routing: PropTypes.object,
  shoppingCartSetToken: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/app.jsx